import React, { FC, useId } from 'react';

const LinearDashedBorder: FC = () => {
  const raw = useId();
  const gid = `borderGradient-${raw.replace(/[:]/g, '-')}`;

  return (
    <svg
      className="pointer-events-none absolute h-full w-full"
      viewBox="0 0 1156 254.6667"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="4.09%" stopColor="#7E77B3" />
          <stop offset="27.63%" stopColor="#8989FF" />
          <stop offset="51.07%" stopColor="#6C9DFF" />
          <stop offset="74.69%" stopColor="#78CFDA" />
          <stop offset="98.23%" stopColor="#9FF4A9" />
        </linearGradient>
      </defs>

      <rect
        x="1"
        y="1"
        width="1154"
        height="252.6667"
        fill="none"
        stroke={`url(#${gid})`}
        strokeWidth="2"
        strokeDasharray="4.625 2.3125"
        rx="4"
        ry="4"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export default LinearDashedBorder;
